/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserGroupSummaryResponse {
    getFixupPrototypeFunction() { return UserGroupSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<UserGroupSummaryResponse>): UserGroupSummaryResponse {
        let obj = Object.assign(new UserGroupSummaryResponse(), model);
        UserGroupSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserGroupSummaryResponse>): UserGroupSummaryResponse {
        if (!model) return null;
        return UserGroupSummaryResponse.newInstance(<UserGroupSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserGroupSummaryResponse) {
        if (!obj) return;

        models.UserGroupSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserGroupSummaryResponse): boolean {
        Object.setPrototypeOf(obj, UserGroupSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_groups === undefined) {
            this.total_groups = 0;
        }
        if (this.assigned_roles === undefined) {
            this.assigned_roles = 0;
        }
        if (this.users === undefined) {
            this.users = 0;
        }
    }

    /**
     * Total number of user groups visible to the caller
     */
    total_groups: number;

    /**
     * Number of distinct roles assigned across those user groups
     */
    assigned_roles: number;

    /**
     * Number of distinct users that belong to those user groups
     */
    users: number;

}
